<script>
import Vue from "vue";
export default {
  methods: {
    getRoleLabel(role) {
      let roles = {
        learner_reviewer: 'Learner',
        coach: window.drupalSettings.group_catch_config.labels.coach_label != '' ?
          window.drupalSettings.group_catch_config.labels.coach_label :
          'Coach',
        subgroup_administrator: 'Admin',
        group_administrator: 'Admin',
      }
      return roles[role];
    },

    getMainMenu($mq) {
      let menu = [];
      let bestPracticeLibraryLabel =
        window.drupalSettings.group_catch_config.labels.best_practice_library;
      let helpCenterUrl =
        window.drupalSettings.group_catch_config.labels.help_center_link;
      let assignmentLabel =
        window.drupalSettings.group_catch_config.labels.assignment_label;
      let manageAssignmentsTitle =
        window.drupalSettings.group_catch_config.labels.manage_assignments_title;
      let current_view = +window.drupalSettings.user.current_view;
      let users_view = Object.values(window.drupalSettings.user.user_views_by_roles);
      let manageObservationsTitle =
        window.drupalSettings.group_catch_config.labels.manage_observations_title;
      let observationLabel =
        window.drupalSettings.group_catch_config.labels.observation_label;

      switch (users_view[current_view - 1]) {
        case 'administrator':
          menu = [
            {
              title: "Dashboard",
              path: "teacher-dashboard",
              icon: "home"
            },
            {
              title: "Submissions",
              path: "submissions"
            },
            {
              title: bestPracticeLibraryLabel,
              path: "best-practices"
            },
            {
              title: "Profile",
              menu: [
                {
                  title: "Edit Profile",
                  path: "profile"
                },
                {
                  title: "Log Out",
                  path: "user/logout"
                }
              ]
            },
          ];
          break;

        case 'learner_reviewer':
          menu = [
            {
              title: "Home",
              path: "learner",
              icon: "home"
            },
            {
              title: "Dashboard",
              path: "teacher-dashboard"
            },
            {
              title: bestPracticeLibraryLabel,
              path: "best-practices"
            },
            {
              title: "Profile",
              menu: [
                {
                  title: "Edit Profile",
                  path: "profile"
                },
                {
                  title: "Log Out",
                  path: "user/logout"
                }
              ]
            },
          ];
          break;

        case 'coach':
          menu = [
            {
              title: "Home",
              path: "coach",
              icon: "home"
            },
            {
              title: "Dashboard",
              path: "rubric-submissions",
              items: [
                {
                  title: "Review Submissions",
                  path: "rubric-submissions"
                },

                {
                  title: manageAssignmentsTitle,
                  path: "assignments",
                  restricted: true,
                  access: function () {
                    let groupSettings = window.drupalSettings.user.group_settings;
                    if (groupSettings) {
                      if (groupSettings.assignments === "1") {
                        return true;
                      }
                    }
                    return false;
                  }
                },
                {
                  title: manageObservationsTitle,
                  path: "observations",
                  restricted: true,
                  access: function () {
                    let groupSettings = window.drupalSettings.user.group_settings;
                    if (groupSettings) {
                      if (groupSettings.observation === "1") {
                        return true;
                      }
                    }
                    return false;
                  }
                }
              ]
            },
            {
              title: bestPracticeLibraryLabel,
              path: "best-practices"
            },
            {
              title: "Profile",
              menu: [
                {
                  title: "Edit Profile",
                  path: "profile"
                },
                {
                  title: "Log Out",
                  path: "user/logout"
                }
              ]
            },
            {
              title: "Create " + assignmentLabel,
              path: "assignment/add",
              restricted: true,
              access: function () {
                let groupSettings = window.drupalSettings.user.group_settings;
                if (groupSettings) {
                  if (groupSettings.assignments === "1" && ($mq != 'large' && $mq != 'xlarge')) {
                    return true;
                  }
                }
                return false;
              }
            },
            {
              title: "Create " + observationLabel,
              path: "observation/add",
              restricted: true,
              access: function () {
                let groupSettings = window.drupalSettings.user.group_settings;
                if (groupSettings) {
                  if (groupSettings.observation === "1" && ($mq != 'large' && $mq != 'xlarge')) {
                    return true;
                  }
                }
                return false;
              }
            }
          ];
          break;

        case 'subgroup_administrator':
        case 'group_administrator':
          menu = [
            {
              title: "Dashboard",
              path: "dashboard",
              icon: "home"
            },
            {
              title: "Submissions",
              path: "submissions"
            },
            {
              title: bestPracticeLibraryLabel,
              path: "best-practices"
            },
            {
              title: "Profile",
              menu: [
                {
                  title: "Edit Profile",
                  path: "profile"
                },
                {
                  title: "Log Out",
                  path: "user/logout"
                }
              ]
            },
          ];
          break;
      }

      if (Object.keys(window.drupalSettings.user.all_available_roles).length > 1) {
        let optionalRoles = [];
        Object.entries(window.drupalSettings.user.all_available_roles).forEach(([key, value]) =>
        {
          if (users_view[current_view - 1] != value) {
            optionalRoles.push({
              title: this.getRoleLabel(value) + ' View',
              path: 'switch-role/' + value
            });
          }
        });

        menu.push({
          title: this.getRoleLabel(users_view[current_view - 1]) + " View",
          menu: optionalRoles,
          class: "md-small-hide",
        });

        menu.push({
          title: this.getRoleLabel(users_view[current_view - 1]) + " View",
          path: "",
          class: "view-mode-switcher-mobile current-view",
        });
        optionalRoles.forEach((role) => {
          menu.push({
            title: role.title,
            path: role.path,
            class: "view-mode-switcher-mobile",
          });
        })
      }

      menu.push(
        {
          title: "Help Center",
          path: helpCenterUrl,
          target: "_blank",
          external: true,
          mobile: true
        },
        {
          title: "Terms",
          path: "terms",
          target: "_blank",
          mobile: true
        },
        {
          title: "Log out",
          path: "user/logout",
          class: "logout",
          mobile: true
        }
      );

      return menu;
    }
  },
};

</script>

